// ============================================================================
// gjurma.js — GJURMA e llogarisë pa familje (PROVAT1, 6 shtator 2026)
//
// Pronari: «dalin te llogaritë jetime pa asnjë shenjë ç'ka ndodhur — ndoshta
// vetëm bënë login, ndoshta shtypën Krijo — s'di ç'po ndodh».
// Çdo hap i rrugës pa familje shënohet te `join_attempts` (i njëjti regjistër
// si «Bashkohu me kod»): ekrani «pa familje», hapja e /start dhe /join,
// krijimi i familjes, hapat e kodit. Admini e sheh te Llogaritë → Orfane.
// Fire-and-forget: dështimi i logut nuk e prek kurrë rrjedhën.
// ============================================================================
import { supabase } from "./supabaseClient";
import { Capacitor } from "@capacitor/core"; // HYRJET1 — platforma (web/ios/android)

let _iFundit = "";
export function shenoGjurmen(step, code, input, ok, message, familyId) {
  try {
    // i njëjti hap dy herë radhazi (p.sh. rirender) nuk shënohet dy herë
    const celesi = `${step}|${code || ""}|${input || ""}|${ok}|${message || ""}`;
    if (celesi === _iFundit) return;
    _iFundit = celesi;
    supabase.rpc("rpc_log_join_attempt", {
      p_step: step, p_code: code || null, p_input: input || null, p_ok: ok !== false,
      p_message: message || null, p_family_id: familyId || null,
      p_user_agent: (typeof navigator !== "undefined" && navigator.userAgent) ? String(navigator.userAgent).slice(0, 300) : null,
    }).then(() => {}, () => {});
  } catch (_e) { /* asgjë */ }
}

// ============================================================================
// HYRJET1 (9 shtator 2026) — GJURMA E DERËS: çdo tentim rreth hyrjes.
//
// Pronari mori një «Your sign-in link» ndërsa flinte dhe s'kishte ku ta shihte
// kush e kërkoi. Tani çdo veprim te dera shënohet te `auth_events`: hyrje e
// dështuar, Google/Apple (nisi/dështoi), regjistrim, lidhje magjike,
// rivendosje fjalëkalimi, «S'mund të hyj?», hapje ftese, dalje, fshirje.
// IP-në dhe shtetin i lexon vetë serveri nga kokat — këtu s'dërgohen.
// KURRË fjalëkalimi, kurrë kodi i lidhjes. Fire-and-forget.
// Admini e lexon te Regjistri → «Hyrjet & tentimet».
// ============================================================================
export function shenoHyrjen(event, opsionet) {
  try {
    const o = opsionet || {};
    let page = null, slug = o.familySlug || null;
    try {
      page = String(window.location.pathname || "/").slice(0, 200);
      const m = /^\/f\/([a-z0-9-]+)/.exec(page);
      if (!slug && m) slug = m[1];
      if (!slug) slug = localStorage.getItem("pef_family_slug") || null;
    } catch (_e) { /* asgjë */ }
    let platform = "web";
    try {
      const p = o.platform || Capacitor.getPlatform();
      if (p === "ios" || p === "android") platform = p;
    } catch (_e) { /* web */ }
    supabase.rpc("rpc_log_auth_event", {
      p_event: event,
      p_email: o.email ? String(o.email).trim().slice(0, 200) : null,
      p_ok: o.ok !== false,
      p_reason: o.reason ? String(o.reason).slice(0, 500) : null,
      p_family_slug: slug,
      p_page: page,
      p_platform: platform,
      p_user_agent: (typeof navigator !== "undefined" && navigator.userAgent) ? String(navigator.userAgent).slice(0, 300) : null,
    }).then(() => {}, () => {});
  } catch (_e) { /* asgjë */ }
}
